import PropTypes from "prop-types";

export const CognitoAuthDataPropType = PropTypes.shape({
  username: PropTypes.string.isRequired
});



// WEBPACK FOOTER //
// ./src/components/propTypes.jsx